const localeMap: Record<string, string> = {
  en: 'en-BE',
  fr: 'fr-BE',
  nl: 'nl-BE'
};

export default function numberFormatterFactory(
  lang: string,
  options?: Intl.NumberFormatOptions
) {
  return new Intl.NumberFormat(localeMap[lang], options);
}
